<template>
  <div class="company-info" :style="warpperStyle">
    <nav-bar titleText="公司信息 " titleWeight="bold" @goBack="goBack" :isFixed="true" ></nav-bar>
    <div class="divider"></div>
    <div class="content">
      <div class="info van-clearfix">
        <div class="basic_info">
          <van-field
            v-model="value1"
            label="统一社会信用代码"
            format-trigger="onBlur"
            class="marTop12 licensse"
            placeholder="请填写"
            onkeyup="value=value.replace(/[^\w]/ig,'')" 
            onafterpaste="this.value=this.value.replace(/[^\w]/ig,'')"
            @focus="handleFocus"
            @blur="handleBlur"
          />

          <div class="uploadBox">
            <van-uploader 
              v-model="fileList1"
              multiple 
              :max-count="1" 
              preview-size="100px"
              @oversize="onOversize"
              @delete="delectFile1"
              :after-read="afterRead1"
            >
              <div class="box">
                <div class="icon">+</div>
                <div class="title">营业执照照片</div>
              </div>
            </van-uploader>
          </div>

          <van-field
            v-model="value2"
            label="法人姓名"
            format-trigger="onBlur"
            class="marTop12"
            placeholder="请填写"
            @focus="handleFocus"
            @blur="handleBlur"
          />
          
          <van-field
            v-model="value3"
            label="身份证号"
            format-trigger="onBlur"
            class="marTop12"
            placeholder="请输入法人身份证号"
            onkeyup="value=value.replace(/[^\w]/ig,'')" 
            onafterpaste="this.value=this.value.replace(/[^\w]/ig,'')"
            @focus="handleFocus"
            @blur="handleBlur"
          />

          <div class="uploadBox uploadBox1">
            <van-uploader 
              v-model="fileList2"
              multiple 
              :max-count="1" 
              preview-size="100px"
              @oversize="onOversize"
              @delete="delectFile2"
              :after-read="afterRead2"
            >
              <div class="box">
                <div class="icon"><img src="../../../assets/member/indetity/photo.png" alt /></div>
              </div>
            </van-uploader>
            <div class="title">上传带头像一面</div>
          </div>
          <div class="uploadBox uploadBox1 uploadBox2">
            <van-uploader 
              v-model="fileList3"
              multiple 
              :max-count="1" 
              preview-size="100px"
              @oversize="onOversize"
              @delete="delectFile3"
              :after-read="afterRead3"
            >
              <div class="box">
                <div class="icon"><img src="../../../assets/member/indetity/photo.png" alt /></div>
              </div>
            </van-uploader>
            <div class="title">上传带国徽一面</div>
          </div>
        </div>
      </div>
    </div>
    <div class="complete" :style="completeStyle">
      <van-button @click="audit" type="primary" class="operation_btn">提交审核</van-button>
      <div class="complete-empty"></div>
    </div>
    
    <van-dialog
      v-model="dialogShow"
      title="提示"
      confirmButtonColor="#F9591B"
      show-cancel-button
      :closeOnClickOverlay="false"
      @confirm="confirm"
      @cancel="cancel"
    >
      <div v-if="companyInfo">
        <p class="tip">提交后信息不能更改，请确认信息</p>
        <p class="tip">{{companyInfo.company_name}}</p>
        <p class="tip">{{companyInfo.representative_name}}</p>
        <p class="tip tipL">{{companyInfo.social_number || value3}}</p>
      </div>
    </van-dialog>

    <div class="loading" v-if="loading">
      <img src="../../../assets/common/loading.gif" />
    </div>

  </div>
</template>

<script>
import navBar from "../../debtRelief/components/navBar";
import {uploadMixin} from "../../../providers/mixin"
export default {
  data() {
    return {
      value1: "",
      value2: "",
      value3: "",
      companyInfo: {},
      fileList: [],
      fileList1: [],
      fileList_1: [],
      fileList2: [],
      fileList_2: [],
      fileList3: [],
      fileList_3: [],
      client: 0,
      warpperStyle: {height: '100%'},
      completeStyle: {bottom: '0'},
      dialogShow: false,
      count: 0,
      loading:false,
    };
  },
  components: {
    navBar,
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
  },
  mounted() {
    this.deductionUA()
  },
  mixins: [uploadMixin],
  methods: {
    afterRead1(file){
      this._afterRead(file, 'certificate', this.fileList1, this.fileList_1)
    },
    delectFile1(file) {
      this.fileList_1 = [];
    },
    afterRead2(file){
      this._afterRead(file, 'identity', this.fileList2, this.fileList_2)
    },
    delectFile2(file) {
      this.fileList_2 = [];
    },
    afterRead3(file){
      this._afterRead(file, 'identity', this.fileList3, this.fileList_3)
    },
    delectFile3(file) {
      this.fileList_3 = [];
    },
    deductionUA() {
      const ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        this.client = 11; 
      } else if (/android/.test(ua)) {
        this.client = 10;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    handleFocus(e){
      // TODO 没有查到怎么获取手机系统键盘高度 只能写死200px？ 看原生能不能适配键盘弹起会遮挡的问题
      if (this.client === 10) {
        setTimeout(() => {
          this.warpperStyle = {height: 'calc(100% - 200px)'}
          this.completeStyle ={bottom: '200px'}
        },100)
      }
    },
    handleBlur(e){
      if (this.client === 10) {
        setTimeout(() => {
          this.warpperStyle = {height: '100%'}
          this.completeStyle ={bottom: '0'}
        },100)
      }
    },
    audit() {
      // 验证
      if(!this.value1) {
        this.$toast('请填写统一社会信用代码');
        return
      }else if (this.fileList1.length === 0) {
        this.$toast('请上传营业执照图片')
        return
      }else if(!this.value2) {
        this.$toast('请填写法人姓名');
        return
      }else if(!this.value3) {
        this.$toast('请输入身份证号');
        return
      }else if(!this.checkID(this.value3)) {
        this.$toast("身份证号码不存在！");
        return
      }else if (this.fileList2.length === 0) {
        this.$toast('请上传身份证带头像一面的图片')
        return
      }else if (this.fileList3.length === 0) {
        this.$toast('请上传身份证带国徽一面的图片')
        return
      }else if (this.fileList1.length !== this.fileList_1.length) {
        this.$toast('请等待营业执照图片上传完毕')
        return
      }else if (this.fileList2.length !== this.fileList_2.length) {
        this.$toast('请等待身份证带头像一面的图片上传完毕')
        return
      }else if (this.fileList3.length !== this.fileList_3.length) {
        this.$toast('请等待身份证带国徽一面的图片上传完毕')
        return
      }else {
        this.count = 0;
        this.changeUrl(this.fileList_1[0], 0);
        this.changeUrl(this.fileList_2[0], 1);
        this.changeUrl(this.fileList_3[0], 2);
      }
    },
    checkData() {
        console.log(this.fileList)
      const params1 = {
        social_number: this.value1,
        representative_name: this.value2,
        id_card_number: this.value3,
        licence_pic: this.fileList[0],
        id_card_pic: {
          front: this.fileList[1],
          back: this.fileList[2]
        }
      }

      this.$api.post('member/member/company/auth/check', params1)
        .then(data => {
          this.companyInfo = data;
          this.dialogShow = true;
        })
        .catch(err => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0]
          this.$toast(message)
        })
    },
    cancel() {
      this.dialogShow = false;
    },
    confirm() { 
      this.loading = true
      const params = {
        social_number: this.value1,
        representative_name: this.value2,
        id_card_number: this.value3,
        company_name: this.companyInfo.company_name,
        company_no: this.companyInfo.company_no,
        reg_no: this.companyInfo.reg_no,
        start_date: this.companyInfo.start_date,
        licence_pic: this.fileList[0],
        id_card_pic: {
          front: this.fileList[1],
          back: this.fileList[2]
        }
      }
      this.$api.post('member/member/company/auth', params)
      .then(data => {
        this.$router.push({
          path: '/authenticate/result',
          query: {
            from: 'info',
            token: this.$route.query.token
          }
        })
      })
      .catch(err => {
        let keys = Object.keys(err);
        let key = keys[0];
        let message = err.message || err[key][0]
        this.$toast(message)
      })
      .finally(() => {
        this.loading = false
      })
    },

    changeUrl(file, index) {
      this.fileList[index] = file;
      this.count++;
      if(this.count == 3) {
        this.checkData();
      }
      // this.$api.post('contract/member/contract/file/private/url', {file_path: file})
      // .then(res => {
      //   console.log(res.url)
      //   this.fileList[index] = res.url;
      //   this.count++;
      //   if(this.count == 3) {
      //     this.checkData();
      //   }
      // })
      // .catch(err => {
      //   this.$toast(err[Object.keys(err)[0]][0]);
      //   return;
      // })
    },
    checkID (val) {
      if(this.checkCode(val)) {
        var date = val.substring(6,14);
        if(this.checkDate(date)) {
            if(this.checkProv(val.substring(0,2))) {
                return true;
            }
        }
      }
	    return false;
    },
    checkDate(val) {
    	var pattern = /^(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/;
	    if(pattern.test(val)) {
	        var year = val.substring(0, 4);
	        var month = val.substring(4, 6);
	        var date = val.substring(6, 8);
	        var date2 = new Date(year+"-"+month+"-"+date);
	        if(date2 && date2.getMonth() == (parseInt(month) - 1)) {
	            return true;
	        }
	    }
	    return false;
    },
    checkProv(val) {
    	var pattern = /^[1-9][0-9]/;
	    var provs = {11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门"};
	    if(pattern.test(val)) {
	        if(provs[val]) {
	            return true;
	        }
	    }
	    return false;
	    },
    checkCode (val) {
    	var p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
	    var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
	    var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
	    var code = val.substring(17);
	    if(p.test(val)) {
	        var sum = 0;
	        for(var i=0;i<17;i++) {
	            sum += val[i]*factor[i];
	        }
	        if(parity[sum % 11] == code.toUpperCase()) {
	            return true;
	        }
	    }
	    return false;
    },
  }
};
</script>


<style lang="less">
.company-info {
  overflow-x: hidden;
  padding: 88px 0 0;
  box-sizing: border-box;
  color: #333;
  font-size: 16px;
  transition: height 0.1s linear;
  .navbar {
    margin: 24px 5px 0 5px;
  }
  .divider {
    width: 100%;
    height: 12px;
    background-color: #f2f2f2;
  }
  .content {
    padding: 0 12px 107px;
    position: relative;
    .title {
      font-size: 15px;
      min-height: 24px;
      line-height: 24px;
    }
    .van-cell {
      &::after {
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        right: 0;
        bottom: 0;
        left: 16px;
        border-bottom: 1px solid #ebedf0;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
      }
    }
    input::placeholder {
      color: #bababa;
      font-size: 17px;
    }
    .marTop12 {
      margin-top: 12px;
      .van-field__control {
        font-size: 16px;
      }
    }
    .basic_info {
      margin: 9px 0 0 0;
      .van-cell {
        padding: 10px 0;
        &:not(:last-child)::after {
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        right: 0;
        bottom: 0;
        left: 16px;
        border-bottom: 1px solid #ebedf0;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        }
      }
      .van-field__label {
        font-size: 17px;
        color: #333;
        font-weight: bold;
        width: 75px;
        margin-right: 15px;
      }
    }
    .licensse {
      .van-field__label {
        width: 140px;
      }
    }
    .uploadBox {
      margin-top: 18px;
      min-height: 100px;
      .van-image__img, .van-image__error, .van-image__loading {
        object-fit: fill !important;
      }
      .box {
        width: 100px;
        height: 100px;
        border: 1px dashed #dedede;
        box-sizing: border-box;
        .icon {
          text-align: center;
          color: #999999;
          height: 21px;
          line-height: 21px;
          margin: 27px 0 9px;
          font-size: 35px;
        }
        .title {
          text-align: center;
          font-size: 13px;
          height: 21px;
          line-height: 21px;
          color: #555555;
        }
      }
    }
    .uploadBox1 {
      width: 50%;
      float: left;
      .title {
        color: #999;
        font-size: 14px;
        height: 20px;
        line-height: 20px;
        margin-top: 8px;
        text-align: center;
      }
      .van-uploader {
        width: 100%;
        .van-uploader__input-wrapper {
          width: 100%;
          padding-right: 10px;
          .box {
            width: 100%;
					  background: url(../../../assets/member/indetity/id_front.png) no-repeat center center;
            background-size: 100% 100%;
            img {
              width: 44px;
            }
          }
        }
        .van-uploader__preview {
          width: 100%;
          margin-right: 10px;
          .van-uploader__preview-image {
            width: 100% !important;
            .van-image__img, .van-image__error, .van-image__loading {
              object-fit: fill !important;
            }
          }
        }
      }
    }
    .uploadBox2 {
      .van-uploader {
        .van-uploader__input-wrapper {
          padding-left: 10px;
          .box {
					  background: url(../../../assets/member/indetity/id_back.png) no-repeat center center;
            background-size: 100% 100%;
          }
        }
        .van-uploader__preview {
          margin-left: 10px;
          margin-right: 0px;
        }
      }
    }

  }
  .complete {
    position: fixed;
    // bottom: 0;
    padding: 0 12px;
    // width: calc(100% - 24px);
    box-sizing: border-box;
    width: 100%;
    background-color: #ffffff;
    transition: bottom 0.1s linear;
    .complete-empty {
      background-color: #ffffff;
      height: 24px;
      width: 100%;
    }
    .operation_btn {
      background-color: #fc740c;
      color: #fff;
      border: none;
      width: 100%;
      margin: 0 auto;
      height: 50px;
      font-size: 17px;
      display: block;
      border-radius: 20px;
      line-height: 50px;
      font-weight: 600;
    }
  }
  .van-uploader__preview-delet {
    font-size: 26px;
  }
  
  .tip {
    padding: 0 10px;
    text-align: left;
  }
  .tipL {
    margin-bottom: 24px;
  }
  .van-dialog__header {
    padding: 20px 0 24px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
  }

  .loading {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    img {
      width: 35%;
      margin-top: 65%;
    }
  }

}
</style>





